import { utagLinkSort, utagLinkSortSearch } from 'features/tealium';

import doContextualSearch from './doContextualSearch';

const trackContextualSearchEvents = utagLinkSort();
const isViewOnSaleItemsPage = !!(window.location.pathname.toLowerCase() === '/sales_on-sale/');

const initContextualSearch = (searchInputSelector, searchBtnSelector) => {

	const searchInput = document.querySelector(searchInputSelector);
	const searchBtn = document.querySelector(searchBtnSelector);
	const pageCategory =		window.utag_data.product_category[0] && !window.lp.pageData.isMultiSelectSort
		? window.utag_data.product_category[0].toLowerCase()
		: 'site';
	const searchSite = document.querySelector('#searchSite');
	if (!searchInput) {

		return;

	}

	if (searchSite) {

		if (isViewOnSaleItemsPage) {

			searchSite.innerText = 'Search the sale:';

		} else {

			searchSite.innerText = `Search our ${pageCategory}:`;

		}

	} else {

		if (isViewOnSaleItemsPage) {

			searchInput.placeholder = 'Search the sale';

		} else {

			searchInput.placeholder = `Search our ${pageCategory}`;

		}

	}

	const searchHandler = (e) => {

		e.preventDefault();

		const value = searchInput.value.trim();

		if (value === '') {

			return;

		}
		trackContextualSearchEvents({
			eventAction: `Bottom-${pageCategory}-Search-Submit`,
			eventLabel: searchInput.value.trim().toLowerCase()
		});
		utagLinkSortSearch(searchInput.value);
		doContextualSearch(searchInput.value.trim());

	};

	searchBtn.addEventListener('click', (e) => {

		searchHandler(e);

	});

	searchInput.addEventListener('keydown', (e) => {

		if (e.key === 'Enter') {

			searchHandler(e);

		}

	});

};

export default initContextualSearch;
